import { Box, Typography, useTheme } from "@mui/material";
import CopyableTypography from "components/Typography/CopyableTypography";

interface InfoFieldProps {
  label: string;
  value: string;
}

export function InfoField({ label, value }: InfoFieldProps) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        py: 0.5,
        minHeight: "32px",
      }}
    >
      <Typography
        variant="body2"
        sx={{
          color: theme.palette.text.secondary,
          fontWeight: 400,
          minWidth: "180px",
          mr: 2,
        }}
      >
        {label}
      </Typography>
      <CopyableTypography text={value} />
    </Box>
  );
}
